import { render, staticRenderFns } from "./SettingsPanelVariantsOptionItem.vue?vue&type=template&id=5b8239d4&scoped=true"
import script from "./SettingsPanelVariantsOptionItem.vue?vue&type=script&lang=js"
export * from "./SettingsPanelVariantsOptionItem.vue?vue&type=script&lang=js"
import style0 from "./SettingsPanelVariantsOptionItem.vue?vue&type=style&index=0&id=5b8239d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8239d4",
  null
  
)

export default component.exports